(() => {
  class OutboundCallFormController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog, Utils, Orders, Notifications) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        Utils,
        Orders,
        Notifications,
        outboundVisit: $scope.ngDialogData.outboundVisit // characterCount: 0

      });
      this.characterCount = this.outboundVisit.followup.notes ? this.outboundVisit.followup.notes.length : 0;
      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.lemonaid-pharmacy-form-modal").children(".ngdialog-content").draggable({
          handle: ".lemonaid-handler"
        });
      }); // As Meryl confirmed
      // We will always show ALL statuses
      // We will not restrict any status by now => Change on the original design
      // Maybe in the future we will

      this.OutboundCallVisitStatuses = [{
        type: "all",
        name: 'All Statuses'
      }, {
        type: "call_needed",
        name: 'Call Needed'
      }, {
        type: "left_message",
        name: 'Left Message'
      }, {
        type: 'call_completed',
        name: 'Call Completed'
      }, {
        type: 'follow_up',
        name: 'Follow Up'
      }]; // this.getDetails();
    }

    checkNewStatus(newStatus, oldStatus) {
      // As Maksim mentioned in the ticket
      // 'Incomplete' status shouldn't be an option
      // we need to remove 'Cancelled' status, Patient Support has to cancel the fills
      // As Greg confirmed
      // User should not change a fill request to "open"
      // console.log("newStatus: ",newStatus);
      // console.log("oldStatus: ", oldStatus);
      // if (oldStatus === 'incomplete' || newStatus === 'incomplete' ||
      //   oldStatus === 'cancelled' || newStatus === 'cancelled' ||
      //   oldStatus === 'open' || newStatus === 'open') {
      if (oldStatus === 'cancelled' || newStatus === 'cancelled') {
        this.pharmacyfill.status = oldStatus;
        this.toastr.warning("Status can't be changed from '" + oldStatus + "' to '" + newStatus + "'.");
      }
    }

    getDetails() {// this.Orders.getLemonaidPharmacyMailorder(this.pharmacyfill_id)
      // .then(({ data }) => {
      //   this.pharmacyfill = data;
      //   if (!this.pharmacyfill.fulfillment_quantity) {
      //     this.pharmacyfill.fulfillment_quantity = this.pharmacyfill.num_to_send * this.pharmacyfill.dispense_amount;
      //   }
      //   if (!this.pharmacyfill.fulfillment_days_supply) {
      //     this.pharmacyfill.fulfillment_days_supply = this.pharmacyfill.num_to_send * this.pharmacyfill.days_supply;
      //   }
      //   if (this.pharmacyfill.shipment && !this.pharmacyfill.shipment.tracking_url) {
      //     this.pharmacyfill.shipment.tracking_url = "https://tools.usps.com/go/TrackConfirmAction?tLabels=";
      //   }
      // })
      //.catch((err) => this.toastr.error(this.Notifications.generic.failure));
      // .finally(() => { this.loading = false; });
    }

    close() {
      this.$scope.closeThisDialog(null);
    }

    update() {
      var payload = {
        status: this.outboundVisit.followup.status,
        notes: this.outboundVisit.followup.notes ? this.outboundVisit.followup.notes : ""
      };
      this.Orders.updateOutboundCallVisit(this.outboundVisit.id, payload).then(() => {
        this.toastr.success("Details were updated successfully.");
        var response = {
          success: true
        };
        this.$scope.closeThisDialog(response);
      }).catch(err => {
        if (err && err.data && err.data.message && err.data.message.summary) {
          this.toastr.error(err.data.message.summary);
        } else {
          this.toastr.error(this.Notifications.generic.failure);
        }
      });
    }

    countCharacters() {
      this.characterCount = this.outboundVisit.followup.notes.length;
    }

  }

  OutboundCallFormController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog", "Utils", "Orders", "Notifications"];
  angular.module('pims').controller('OutboundCallFormController', OutboundCallFormController);
})();